import { Icon } from '@cfa/react-components';

const DeviceImacSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M11.5 17h-7.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9" />
    <path d="M3 13h18" />
    <path d="M8 21h3.5" />
    <path d="M10 17l-.5 4" />
    <path d="M20 21l2 -2l-2 -2" />
    <path d="M17 17l-2 2l2 2" />
  </svg>
);

const DeviceImacIcon = () => (
  <Icon icon={DeviceImacSvg} />
);

export default DeviceImacIcon;
